import { Joi, objectSchemaOf } from '../helpers';
import type { StartMethod } from './conversation';
import { startMethod } from './conversation';

export const startParamsSchema = objectSchemaOf<IStartParams>({
  conversationId: Joi.string().required(),
  startMethod: Joi.string()
    .valid(...startMethod)
    .optional(),
  snapshotId: Joi.string().optional(),
  faceId: Joi.string().optional(),
});

export interface IStartParams {
  conversationId: string;
  startMethod?: StartMethod;
  snapshotId?: string;
  faceId?: string;
}
